import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import moment from 'moment';
import OpportunityFormViewer from '@organisms/opportunities/OpportunityFormViewer';
import MainTemplate from '@templates/MainTemplate';

import { initializeApollorWithQueries, addApolloState } from '@app/config/apollo';
import { APPLICATION_FORM } from '@app/apollo/queries';
import { redirectToRoute } from '@app/helpers';
import { i18n } from '@app/config/i18n';
import OpportunitySeo from '@molecules/SEO/OpportunitySeo';
import { OPP_STATUS_ENUM } from '@app/constants';
// import {isAdmin, isOrganiser} from '../../../helpers/authorization'

const canApply = (opportunity) => {


  if (opportunity.deadline_date) {

    return moment(opportunity.deadline_date).diff(moment()) > 0;
  }

  if (!opportunity.deadline_date && opportunity.start_date) {
    return moment(opportunity.start_date).diff(moment()) > 0;
  }

  return true;
};

const FormViewerPage = () => {
  const router = useRouter();
  const { slug: opportunitySlug } = router.query;
  const [showTerms, setShowTerms] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);

  const {
    data: { applicationForm = null, instruments = [], genres = [] } = {},
    loading: fromLoading,
    refetch,
  } = useQuery(APPLICATION_FORM, {
    variables: {
      opportunity: opportunitySlug,
      parent_id: null,
    },
  });

  if (refetch) {
    i18n.on('languageChanged', refetch);
  }

  const { opportunity } = applicationForm || {};

  useEffect(() => {
    if (opportunity.opp_status !== OPP_STATUS_ENUM.PUBLISHED && opportunity.opp_status !== OPP_STATUS_ENUM.ACTIVE) {
      redirectToRoute({}, 'view_opportunity', { params: { slug: opportunity.slug } });
    }
  }, [opportunity]);

  // useEffect(() => {
  //   if (opportunity && opportunity.payment_details && opportunity.slots_status) {
  //     opportunity.payment_details.forEach((payment) => {
  //       opportunity.slots_status.forEach((slot) => {
  //         if (payment.code === slot.code) {
  //           if (payment.slots <= slot.slots) {
  //             redirectToRoute({}, 'view_opportunity', { params: { slug: opportunity.slug } });
  //           }
  //         }
  //       })
  //     })
  //   }
  // }, [])

  const [initialValue, setInitialValue] = useState({
    opportunity: opportunitySlug,
    name: '',
    artist_name: '',
    email: '',
    address: '',
    fields: {},
    members: [],
    instrument_name: {},
    recaptcha: null,
    applicationId: null,
  });

  // useEffect(() => {
  //   //  const defaultLang = getLocalStorage('defaultLang');
  //   if (applicationForm) {
  //     const isLanguageSuported = applicationForm.supported_languages.includes(i18n.language);

  //     // if (defaultLang) {
  //     //   i18n.changeLanguage(defaultLang);
  //     //      localStorage.removeItem('applicationId');
  //     // } else
  //     if (!isLanguageSuported) {
  //       i18n.changeLanguage(applicationForm.supported_languages[0]);
  //     }
  //   }
  // }, []);

  return (
    <>
      {opportunity && <OpportunitySeo opportunity={opportunity} isApply />}
      <MainTemplate>
        {applicationForm && 
          <OpportunityFormViewer
            opportunitySlug={opportunitySlug}
            applicationForm={applicationForm}
            instruments={instruments}
            genres={genres}
            loading={fromLoading}
            initialValue={initialValue}
            setInitialValue={setInitialValue}
            showTerms={showTerms}
            setShowTerms={setShowTerms}
            agreeTerms={agreeTerms}
            setAgreeTerms={setAgreeTerms}
            defaultFormLang={applicationForm?.supported_languages[0]}
          />
        }
      </MainTemplate>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query;

  const {
    apolloClient,
    data: [{ applicationForm } = {}],
  } = await initializeApollorWithQueries(ctx, [
    {
      query: APPLICATION_FORM,
      variables: {
        opportunity: slug,
        parent_id: null,
      },
    },
  ]);

  const { opportunity } = applicationForm || {};
  const isDraft = opportunity.is_draft || opportunity.opp_status === OPP_STATUS_ENUM.DRAFT;

  if ((opportunity && !canApply(opportunity)) || isDraft ) {
    redirectToRoute(ctx, 'view_opportunity', {
      params: {
        slug,
      },
    });
  }

  return addApolloState(apolloClient, {
    props: {
      namespacesRequired: [
        'common',
        'dashboard',
        'wizard',
        'applications',
        'opportunity',
        'payment',
      ],
    },
    notFound: !applicationForm,
  });
}

export default FormViewerPage;
